module.exports = __webpack_public_path__ + "static/media/iphone XR banner3.9abe4cd0.jpg";